import { Injectable } from "@angular/core";
import { AccountData } from "../../model/core/AccountData";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class AccountDataAdapter {
  constructor() {}

  public transformAccount(account: CubiqTS.AccountImpl): AccountData {
    let result: AccountData = null;

    if (account) {
      result = new AccountData();

      result.accountCd = account.id;
      result.accountName = account.name;
      result.clientCd = account.clientId;
    }

    return result;
  }
}
